import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { CheckOutlined } from "@ant-design/icons";
import {
  CURRENCY,
  FREE_DELIVERY_FROM_PRICE,
} from "../../constants/DeliveryConstants";
import { colors } from "../../utils/theme";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

const UspBar = () => {
  const { t } = useTranslation();

  const items = [
    {
      key: "free",
      text: t("header_usps.free_shipping", {
        amount: `${CURRENCY}${FREE_DELIVERY_FROM_PRICE}`,
      }),
    },
    {
      key: "chilled",
      text: t("header_usps.chilled_delivery"),
    },
    {
      key: "nextday",
      text: t("header_usps.next_day_delivery"),
    },
  ];

  return (
    <BannerWrapper aria-label="USP banner">
      <SwiperWrapper
        spaceBetween={0}
        slidesPerView={1}
        breakpoints={{
          768: { slidesPerView: 3 },
        }}
        loop
        autoplay={{ delay: 3500, disableOnInteraction: false }}
        modules={[Autoplay]}
        aria-label="USP slider"
      >
        {items.map((item) => (
          <SwiperSlide key={item.key}>
            <Usp as={"div"}>
              <CheckOutlined className="icon" style={{ margin: 0 }} />
              <span>{item.text}</span>
            </Usp>
          </SwiperSlide>
        ))}
      </SwiperWrapper>
    </BannerWrapper>
  );
};

export default UspBar;

const BannerWrapper = styled.div`
  width: 100%;
  background: ${colors.primary};
  color: #fff;
`;

const SwiperWrapper = styled(Swiper)`
  min-height: 38px;
  padding: 6px 0;
  align-content: center;

  .swiper-wrapper {
    align-items: center;
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
  }
`;

const Usp = styled.button`
  appearance: none;
  border: 0;
  background: transparent;
  color: inherit;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  line-height: 1.3;
  padding: 4px 10px;

  .icon {
    font-size: 14px;
  }
`;
